import { Text } from '@vtex/admin-ui'
import { FormattedMessage } from 'react-intl'
import { useNumbers } from 'ui/components/utils/useNumbers'
import { MaxPrice } from '../../../../../typings'
import { ReviewProps } from './constants'
import { messages } from './messages'

export function MaxPriceRecap(props: ReviewProps) {
  const { config } = props

  const { formatCurrency } = useNumbers()

  if (!config.benefit || !config.scope) return null

  const { benefit, scope } = config

  return (
    <FormattedMessage
      {...messages.maxPrice}
      values={{
        b: (content) => <Text variant="action1">{content}</Text>,
        discount: formatCurrency((benefit as MaxPrice).value),
        applyTo: scope.applyTo,
      }}
    />
  )
}
